export default "__VITE_ASSET__sUq07A8a__"